import Field from '@ui/Field'
import Input from '@ui/Input'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  onChange: (value: string) => void
}

/**
 * The 6-digit authenticator code. Marked one-time-code (not a password) so
 * autofill offers the code instead of a saved password.
 */
const OneTimeCodeField = ({ value, onChange }: Props) => {
  const { t } = useTranslation()
  return (
    <Field label={t('auth.password.totp-code')}>
      <Input
        variant="mono"
        inputMode="numeric"
        name="one-time-code"
        autoComplete="one-time-code"
        spellCheck={false}
        pattern="[0-9]*"
        maxLength={6}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
        required
      />
    </Field>
  )
}

export default OneTimeCodeField
